import type { Habit } from '../../services/habitService'
import { makeDefaultScheduleValue, type HabitScheduleValue } from './HabitScheduleEditor'
import { buildRRule, rruleFromLegacy } from '../../utils/rrule'

/** Build the schedule editor's state from a loaded habit, falling back to the legacy fields. */
export function scheduleFromHabit(data: Habit): HabitScheduleValue {
  const base = makeDefaultScheduleValue()
  const ft = {
    nag_enabled: data.nag_enabled ?? base.nag_enabled,
    follow_through_mode: data.follow_through_mode ?? base.follow_through_mode,
    nag_window_minutes: data.nag_window_minutes ?? base.nag_window_minutes,
    nag_interval_minutes: data.nag_interval_minutes ?? base.nag_interval_minutes,
    nag_max_per_window: data.nag_max_per_window ?? base.nag_max_per_window,
    nag_style: data.nag_style ?? base.nag_style,
  }
  if (data.rrule && data.scheduled_times_local && data.scheduled_times_local.length > 0) {
    return {
      ...base, ...ft,
      rrule: data.rrule,
      scheduled_times_local: data.scheduled_times_local,
      schedule_start_date: data.schedule_start_date || base.schedule_start_date,
      duration_minutes: data.duration_minutes || 30,
      target_cadence: data.target_cadence || 'daily',
      preferred_days: (data.preferred_days as string[]) || [],
      preferred_time_window: data.preferred_time_window || 'morning',
    }
  }
  const { spec, times } = rruleFromLegacy(data.target_cadence, data.preferred_days as string[] | undefined, data.preferred_time_window)
  return {
    ...base, ...ft,
    rrule: buildRRule(spec),
    scheduled_times_local: data.preferred_start_time ? [data.preferred_start_time] : times,
    duration_minutes: data.duration_minutes || 30,
    target_cadence: data.target_cadence || 'daily',
    preferred_days: (data.preferred_days as string[]) || [],
    preferred_time_window: data.preferred_time_window || 'morning',
  }
}
